<template>
  <Teleport to="body">
    <div v-if="open" class="mv-sheet-overlay" @click="$emit('close')">
      <div class="mv-sheet" @click.stop>
        <div class="mv-sheet-handle"></div>
        <div class="mv-sheet-title">Etiquetas</div>
        <div v-if="!allLabels.length" class="mv-sheet-loading">
          <div class="mv-spinner" style="width:22px;height:22px;border-width:2px;"></div>
        </div>
        <label
          v-for="lbl in allLabels"
          :key="lbl.id"
          class="mv-lbl-opt"
          :class="{ checked: currentLabels.includes(lbl.title) }"
          @click.prevent="(currentLabels.includes(lbl.title) && protectedTitles.has(lbl.title)) || $emit('toggle', lbl.title)"
        >
          <span class="mv-lbl-dot" :style="{ background: lbl.color }"></span>
          <span class="mv-lbl-opt-name">{{ lbl.title.replace(/_/g, ' ') }}</span>
          <svg v-if="currentLabels.includes(lbl.title) && protectedTitles.has(lbl.title)" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" style="margin-left:auto;color:#9CA3AF;flex-shrink:0" title="Etiqueta protegida — não pode ser removida">
            <rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
          </svg>
          <svg v-else-if="currentLabels.includes(lbl.title)" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" style="margin-left:auto;color:#22c55e;flex-shrink:0">
            <polyline points="20 6 9 17 4 12"/>
          </svg>
        </label>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import type { LabelItem } from '@/types/chat'

defineProps<{
  open: boolean
  allLabels: LabelItem[]
  currentLabels: string[]
  protectedTitles: Set<string>
}>()

defineEmits<{
  close: []
  toggle: [label: string]
}>()
</script>

<style scoped>
/* Compartilhado com outros bottom sheets */
.mv-sheet-overlay {
  position: fixed; inset: 0;
  background: rgba(0,0,0,.4);
  z-index: 2000;
  display: flex; flex-direction: column; justify-content: flex-end;
}
.mv-sheet {
  background: #fff;
  border-radius: 18px 18px 0 0;
  padding: 12px 0 max(20px, env(safe-area-inset-bottom));
  max-height: 72vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.mv-sheet-handle {
  width: 36px; height: 4px;
  background: #E5E7EB; border-radius: 2px;
  margin: 0 auto 14px;
}
.mv-sheet-title {
  font-size: 11.5px; font-weight: 700;
  color: #9CA3AF;
  text-transform: uppercase; letter-spacing: .7px;
  padding: 0 18px 8px;
}
.mv-sheet-loading { display: flex; justify-content: center; padding: 24px; }
.mv-spinner {
  width: 32px; height: 32px;
  border: 3px solid #E5E7EB;
  border-top-color: #BC0C24;
  border-radius: 50%;
  animation: spin .8s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }

/* ══ Lista de etiquetas ══ */
.mv-lbl-opt {
  display: flex; align-items: center; gap: 10px;
  padding: 13px 18px;
  border-bottom: 1px solid #F3F4F6;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
.mv-lbl-opt:last-child { border-bottom: none; }
.mv-lbl-opt:active { background: #F7F7F7; }
.mv-lbl-opt.checked { background: rgba(34,197,94,.04); }
.mv-lbl-dot { width: 10px; height: 10px; border-radius: 50%; flex-shrink: 0; }
.mv-lbl-opt-name { font-size: 14px; font-weight: 500; color: #1A1A1A; flex: 1; }
</style>
